import { useState } from "react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { COLORS, ICONS, subjectMeta, subjectStyle } from "@/lib/constants";

export const SubjectStylePicker = ({ name }) => {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const styles = user?.subject_styles;
  const meta = subjectMeta(name, styles);
  const current = subjectStyle(name, styles);
  const save = async (patch) => {
    try { const { data } = await api.put("/subjects/style", { name, ...patch }); setUser(data); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`subject-style-${name}`} aria-label="Couleur et icône" title="Changer la couleur et l'icône"
          className={`inline-flex h-8 w-8 items-center justify-center rounded-lg ring-primary/40 transition-[box-shadow,transform] hover:scale-105 hover:ring-2 ${meta.tone}`}>
          <meta.icon className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 rounded-2xl p-4" data-testid={`subject-style-popover-${name}`}>
        <p className="eyebrow mb-2">Couleur</p>
        <div className="grid grid-cols-6 gap-2">
          {Object.entries(COLORS).map(([k, c]) => (
            <button key={k} data-testid={`subject-color-${k}`} title={c.label} onClick={() => save({ color: k })}
              className={`h-8 w-8 rounded-full ${c.dot} transition-transform hover:scale-110 ${current.color === k ? "ring-2 ring-foreground ring-offset-2 ring-offset-popover" : ""}`} />
          ))}
        </div>
        <p className="eyebrow mb-2 mt-4">Icône</p>
        <div className="grid grid-cols-6 gap-1.5">
          {Object.entries(ICONS).map(([k, Icon]) => (
            <button key={k} data-testid={`subject-icon-${k}`} aria-label={`Icône ${k}`} title={k} onClick={() => save({ icon: k })}
              className={`inline-flex h-9 w-9 items-center justify-center rounded-lg transition-colors ${current.icon === k ? meta.tone + " ring-1 ring-current" : "text-muted-foreground hover:bg-muted hover:text-foreground"}`}>
              <Icon className="h-4 w-4" />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
